import { createContext, useEffect, useState } from "react";
import { sellBoostFetch } from "../utlifyFunction";
import useAuth from "../hooks/useAuth";

export const DataContext = createContext(null);

const DataProvider = ({ children }) => {
	const { isAuthenticated,user, loading } = useAuth();
	const [packagesData, setPackagesData] = useState(null);
	const [creditData, setCreditData] = useState({
		total: 0,
		used: 0,
		available: 0,
		recentTransactions: [],
	});

	const fetchPackages = async () => {
		try {
			const response = await sellBoostFetch("GET", "/credits/packages");
			console.log(response?.data);
			if (response?.data) {
				setPackagesData(response.data);
			}
		} catch (error) {
			console.log(error);
		}
	};

	const fetchCredits = async () => {
		try {
			const response = await sellBoostFetch("GET", "/credits/balance");
			if (response?.data) {
				setCreditData(response.data);
			}
		} catch (error) {
			console.log(error);
		}
	};

	useEffect(() => {
        console.log(isAuthenticated,user,'isAuthenticated')
		if (user) {
			fetchCredits();
			fetchPackages();
		}
	}, [isAuthenticated]);

	return (
		<DataContext.Provider
			value={{
				creditHandlers: {
					creditData,
					fetchCredits,
					packagesData,
					fetchPackages,
				},
			}}
		>
			{children}
		</DataContext.Provider>
	);
};
export default DataProvider;
